import { useAction, useAtom } from '@reatom/npm-react'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AsyncStateN } from '@blade/std-lib'

import { reatomCreateReportUserForm } from '../../atoms/reatom-report-user-form'

import { ReportForm } from './report-form'
import { ReportUserHeader } from './report-user-header'

import type { ReportFormValues } from './report-form'
import type { UserShort } from '@root/entities/user-short'

type ReportUserFormProps = {
  user: UserShort.UserShort
  onDone: () => void
}

export const ReportUserForm: React.FC<ReportUserFormProps> = ({
  onDone,
  user,
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomCreateReportUserForm(), [])
  const [requestState] = useAtom(model.requestState)
  const executeRequest = useAction(model.requestState.execute)

  const handleSubmit = (values: ReportFormValues) => {
    executeRequest({
      ...values,
      delugeId: user.delugeId,
    })
  }

  useEffect(() => {
    if (AsyncStateN.isSuccess(requestState)) {
      onDone()
    }
  }, [requestState, onDone])

  return (
    <Root>
      <ReportUserHeader user={user} />
      <ReportForm state={requestState} onSubmit={handleSubmit} />
    </Root>
  )
}

const Root = styled.div``
